import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { media } from 'common/media';

const ImageSectionStack = styled(Stack)`
  position: relative;
  margin-left: 8px;
  margin-right: 8px;
  padding-left: 38px;
  padding-right: 38px;
  padding-top: 24px;
  height: calc(100% - 248px);
  @media ${media.sm} {
    margin-left: 24px;
    margin-right: 24px;
  }
  user-select: none;
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
`;

const DescriptionSection = styled(ContentContainer)`
  height: 170px;
  user-select: none;
`;

const DescriptionContainer = styled.div`
  border-radius: 8px;
  background: #20212566;
  padding: 8px;
  color: ${color.textInverse};
`;

type Props = {
  description: string;
  imageUrl: string;
  isOnFirstStep: boolean;
  isOnLastStep: boolean;
  handleTouchStart: () => void;
  handlePreviousTouchEnd: () => void;
  onPreviousStep: () => void;
  handleNextTouchEnd: () => void;
  onNextStep: () => void;
};

export const ImageLargeSlide = ({ description, imageUrl }: Props) => (
  <>
    <ImageSectionStack justifyContent="center" alignItems="center">
      <Image src={imageUrl} />
    </ImageSectionStack>
    <DescriptionSection>
      <DescriptionContainer>
        <T.body>{description}</T.body>
      </DescriptionContainer>
    </DescriptionSection>
  </>
);
